<div class="number-selector">
    <div class="number-selector-minus" (click)="sub()">
        <i class="far fa-minus"></i>
    </div>
    <div class="number-selector-val">{{ value }}</div>
    <div class="number-selector-plus"(click)="add()">
        <i class="far fa-plus"></i>
    </div>
</div>